import React from 'react'
import styled from 'styled-components'

import ProfileDialog from '../custom-dialogs/profile'
import ColoredDialogBackdrop from '../custom-dialogs/colored-dialog-backdrop'
import { useDialog } from '../dialog/hook'

type ProfilePictureProps = {
  pictureUrl: string | null
  publicId: string
  className?: string
}

const ProfilePicture: React.FunctionComponent<ProfilePictureProps> = ({ pictureUrl, publicId, className }) => {
  const { setComponent } = useDialog()

  return (
    <Container
      className={className}
      src={pictureUrl || require('./images/default.svg')} 
      onClick={() => setComponent(<ProfileDialog publicId={publicId}/>, <ColoredDialogBackdrop bg={"#A2ABBA"}/>)}
    />
  )
}

const Container = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;

  cursor: pointer;
`

export default ProfilePicture